import { withAuthInfo, WithAuthInfoProps } from "@propelauth/react";
import React, { useEffect } from "react";

/**
 * Extension refresh page
 * This page is opened by the Chrome extension via chrome.identity.launchWebAuthFlow
 * It gets the access token from PropelAuth and redirects back to the extension
 */
const ExtensionRefreshPageContent = withAuthInfo((props: WithAuthInfoProps) => {
  useEffect(() => {
    // Get the callback URL from query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const redirectUri = urlParams.get("redirect_uri");

    if (!redirectUri) {
      console.error("[Extension Refresh] No redirect_uri provided");
      return;
    }

    if (!props.isLoggedIn || !props.accessToken) {
      console.error("[Extension Refresh] User not logged in");
      // Redirect back with error - user should log in via main TierZero site first
      window.location.href = `${redirectUri}?error=${encodeURIComponent("Not logged in")}`;
      return;
    }

    // Redirect back to extension with access token
    window.location.href = `${redirectUri}?access_token=${encodeURIComponent(props.accessToken)}`;
  }, [props.isLoggedIn, props.accessToken]);

  return (
    <div className="flex h-screen w-full items-center justify-center bg-gradient-to-b from-midnight to-dark-teal">
      <div className="text-center text-white">
        <div className="mb-4">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"></div>
        </div>
        <h2 className="text-xl font-semibold mb-2">Authenticating Extension...</h2>
        <p className="text-slate-300">This window will close automatically.</p>
      </div>
    </div>
  );
});

// Export with custom layout (no default layout)
const ExtensionRefreshPage = () => <ExtensionRefreshPageContent />;

// Custom getLayout to skip default layout
ExtensionRefreshPage.getLayout = (page: React.ReactElement) => page;

export default ExtensionRefreshPage;
